import { render, staticRenderFns } from "./CardResumoItem.vue?vue&type=template&id=75bf057c&scoped=true"
import script from "./CardResumoItem.vue?vue&type=script&lang=js"
export * from "./CardResumoItem.vue?vue&type=script&lang=js"
import style0 from "./CardResumoItem.vue?vue&type=style&index=0&id=75bf057c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bf057c",
  null
  
)

export default component.exports